import * as React from 'react';
import { StyledMenuItemWrapper } from './styles.js';
import MenuItem from './MenuItem.js';
import Separator from '@doordash/component-separator';
import { Inset } from '@doordash/design-language';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MenuItemWrapper = function MenuItemWrapper(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement(StyledMenuItemWrapper, {
    item: item
  }, item.customContent ? item.customContent : /*#__PURE__*/React.createElement(MenuItem, _extends({
    size: item.size
  }, item)), item.hasSeparator && /*#__PURE__*/React.createElement(Inset, {
    size: Inset.Sizes.Small,
    isSquished: true
  }, /*#__PURE__*/React.createElement(Separator, {
    type: Separator.Types.FullBorder
  })));
};

export { MenuItemWrapper as default };
